import React from "react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { FileDown, FileJson, Download } from "lucide-react";
import { API_BASE } from "../lib/api";

const doExport = async (url, ext, label) => {
  try {
    const token = localStorage.getItem("token");
    const r = await fetch(url, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!r.ok) throw new Error(r.statusText);
    const blob = await r.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `opportunities_${new Date().toISOString().slice(0,10)}.${ext}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
    toast.success(`${label} — file downloaded`);
  } catch (e) { toast.error("Export failed"); }
};

export default function Exports() {
  return (
    <div className="p-8" data-testid="exports-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-1">Output</div>
        <h1 className="text-3xl font-bold font-[Chivo] tracking-tight">Exports</h1>
        <p className="text-sm text-zinc-600 mt-2 max-w-2xl">
          Generate analysis-ready exports of active opportunities. Files download directly to your browser.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-zinc-200 bg-white p-6">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">CSV</div>
          <div className="font-bold font-[Chivo] text-lg mb-3">Spreadsheet-ready export</div>
          <p className="text-sm text-zinc-600 mb-4">
            Full 41-column schema with all active opportunities. Opens in Excel, Google Sheets, or any CSV tool.
          </p>
          <Button onClick={() => doExport(`${API_BASE}/export/csv?active_only=true`, "csv", "CSV")} className="rounded-sm bg-[#002FA7] hover:bg-[#002175] text-white" data-testid="export-csv-btn">
            <Download size={14} className="mr-1.5" /> Download CSV
          </Button>
        </div>
        <div className="border border-zinc-200 bg-white p-6">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">JSON</div>
          <div className="font-bold font-[Chivo] text-lg mb-3">Full record dump (pipeline)</div>
          <p className="text-sm text-zinc-600 mb-4">
            All fields including nested documents array. Useful for downstream data pipelines.
          </p>
          <Button onClick={() => doExport(`${API_BASE}/export/json?active_only=true`, "json", "JSON")} variant="outline" className="rounded-sm border-zinc-300" data-testid="export-json-btn">
            <Download size={14} className="mr-1.5" /> Download JSON
          </Button>
        </div>
      </div>
    </div>
  );
}
